import axios from "axios";
import { APP_VERSION } from "../utils/constants.js";

// export const BASE_URL = "http://localhost:5002";
export const BASE_URL = "https://obsessed.potentium.rs";

const API_BASE_URL = `${BASE_URL}/api/`;
const AUTH_BASE_URL = `${BASE_URL}/auth/`;

const axiosAuthClient = axios.create({
  baseURL: AUTH_BASE_URL,
});

const axiosApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

axiosAuthClient.interceptors.request.use(
  (config) => {
    config.headers = {
      version: APP_VERSION,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let store;
export const injectStore = (_store) => {
  store = _store;
};

axiosApiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().authInfo.token;
    config.headers = {
      Authorization: `Bearer ${token}`,
      version: APP_VERSION,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// --- 401 handling: na isteklom access tokenu, osvezi ga preko refresh cookie-ja i ponovi zahtev ---
let isRefreshing = false;
let pendingQueue = [];

const processQueue = (error, token = null) => {
  pendingQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  pendingQueue = [];
};

axiosApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      if (isRefreshing) {
        // Vec se osvezava token — sacekaj u redu pa ponovi
        return new Promise((resolve, reject) => {
          pendingQueue.push({ resolve, reject });
        }).then(() => axiosApiClient(originalRequest));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const { data } = await axiosAuthClient.get("/refresh-token", {
          withCredentials: true,
        });
        const newToken = data?.data?.accessToken;
        // Azuriraj token u redux-u (request interceptor ce ga procitati pri retry-u)
        store.dispatch({
          type: "auth/refresh/fulfilled",
          payload: { accessToken: newToken },
        });
        processQueue(null, newToken);
        return axiosApiClient(originalRequest);
      } catch (refreshErr) {
        processQueue(refreshErr, null);
        // Refresh nije uspeo — odjavi korisnika
        store.dispatch({ type: "logout" });
        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosApiClient;
export { axiosAuthClient, axiosApiClient };
